/* eslint-disable implicit-arrow-linebreak,operator-linebreak */
const baseUrl = () =>
  process.env.VUE_APP_API_BASE_URL ||
  process.env.NEXT_PUBLIC_API_URL ||
  process.env.API_URL;

export default baseUrl;
